import styled from "styled-components"
import { colors } from "../../../utils/styles"

export const CompleteTermsSection = styled.section`
  color: ${colors.primaryBlue};
`
